<template>
  <section class="hero">
      <h1>Cars</h1>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.hero {
  height: 90vh;
  background: url('../../assets/hero.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 90%;
}
h1 {
    font-size: 7rem;
    color: #fff;
    padding-top: 40vh;
    padding-left: 2rem;
}
</style>